var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrend = function SvgIconTrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.467,
    d: "M10.908.233a.53.53 0 0 1 .53.53V3.3a.53.53 0 0 1-.904.374l-.002-.003-.717-.737L6.7 5.986l-.01.011-.013.009h-.003a.67.67 0 0 1-.44.165h-.002a.67.67 0 0 1-.46-.18H5.77L4.108 4.423 1.355 7.019a.68.68 0 0 1-.923.002V7.02a.61.61 0 0 1-.199-.458c0-.229.106-.38.195-.466l.003-.003 3.215-3.028.001-.002a.68.68 0 0 1 .461-.18l.112.01c.108.017.212.06.301.128l.011.01.04.033 1.655 1.56L8.87 2.01l-.873-.874a.529.529 0 0 1 .374-.903z"
  })));
};
export default SvgIconTrend;